import React from 'react';
import {
  SectionDividerRow, SectionDividerLabel, SectionDividerLine, SectionDividerCount,
} from '../styles';

interface Props {
  label: string;
  count?: React.ReactNode;
}

export const SectionDivider: React.FC<Props> = ({ label, count }) => (
  <SectionDividerRow>
    <SectionDividerLabel>{label}</SectionDividerLabel>
    <SectionDividerLine />
    {count != null && <SectionDividerCount>{count}</SectionDividerCount>}
  </SectionDividerRow>
);
